import { Component, Input, inject } from "@angular/core";
import { TabService } from "@services/tabs/TabService";
import { Pages } from "@constants/pages/Pages";
import { provideTranslationScope, TranslatePipe } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/moi/i18n/scope";
import { DateInputComponent } from "@app/shared/components/date-input/date-input.component";
import { InputTooltipDirective } from "@app/shared/directives/input-tooltip.directive";

@Component({
    selector: "moi-incident-summary",
    templateUrl: "./moi-incident-summary.component.html",
    styleUrls: ["./moi-incident-summary.component.scss"],
    imports: [TranslatePipe, DateInputComponent, InputTooltipDirective],
    viewProviders: [provideTranslationScope(scope)],
})
export class MoiIncidentSummaryComponent {
    private tabservice = inject(TabService);
    private pages = inject(Pages);

    @Input() summaryModel: any;
    @Input() incidentGuid: any;

    openIncident() {
        this.tabservice.generateTab(this.pages.IncidentDetail, this.incidentGuid);
    }
}
